// import {
// call,
// put,
// take,
// select,
// race,
// fork,
// takeLatest,
// } from 'redux-saga/effects';
// import {
//   FETCH_HOME_PROMO_FAILURE,
//   FETCH_HOME_PROMO_SUCCESS,
//   FETCH_HOME_PROMO_STARTED,
//   FETCH_HOME_PROMO_NOT_FOUND,
// } from '../actions';
// import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
// import { FRAME_APP_MOUNTED } from '../../../actions/frameActions';
// import { getLanguage } from '../../../selectors/userSelectors';
// import $url from 'url';
// import { getHomeBannerUrl } from '../selectors/configSelectors';

// export function filterBanner(
//   response: any,
//   featureId: any = undefined,
//   filterPolicyNumber: any = undefined,
//   bannerKey = 'banners',
// ) {
//   if (Array.isArray(response)) {
//     return {
//       data: [],
//       userProfile: undefined,
//       policyNumber: undefined,
//       certificateNumber: undefined,
//       dependentNumber: undefined,
//       entityCode: undefined,
//     };
//   }
//   const data: any = [];
//   let userProfile = '';
//   let policyNumber = '';
//   let certificateNumber = '';
//   let dependentNumber = '';
//   let entityCode = '';
//   response.retrieveBannerResponse.policies
//     .filter(
//       (item: any) =>
//         !filterPolicyNumber || item.policyNumber === filterPolicyNumber,
//     )
//     .forEach((policy: any) => {
//       const banners = policy[bannerKey][bannerKey];
//       const profile = banners.find((item: any) => item.profile);
//       const bannerItem = banners.find((item: any) => item.items);
//       if (data.length === 0) {
//         if (bannerItem.items.length > 0) {
//           policyNumber = policy.policyNumber;
//           certificateNumber = policy.certificateNumber;
//           dependentNumber = policy.dependentNumber;
//           entityCode = policy.entityCode;
//           userProfile = profile.profile;
//           bannerItem.items
//             .filter(
//               (item: any) => !featureId || item.content.featureId === featureId,
//             )
//             .forEach((item: any) => {
//               data.push(item.content);
//             });
//         }
//       }
//     });
//   data.forEach((item: any) => {
//     item.query = {
//       landingUrl: item.landingUrl,
//       policyNumber: policyNumber,
//       certificateNumber: certificateNumber,
//       dependentNumber: dependentNumber,
//       entityCode: entityCode,
//       promoCode: item.promoCode ? item.promoCode : '',
//       label: item.headerTitle || '',
//       featureId: item.featureId || '',
//       productType: item.productType || '',
//     };
//   });
//   return {
//     data,
//     userProfile,
//     policyNumber,
//     certificateNumber,
//     dependentNumber,
//     entityCode,
//   };
// }

// function mapBannerObject(data: any) {
//   return data.map((item: any) => {
//     return {
//       title: item.title,
//       description: item.subtitle,
//       query: item.query,
//       image: {
//         mobile: {
//           src: item.image && item.image.mobile && item.image.mobile.src,
//         },
//         desktop: {
//           src: item.image && item.image.desktop && item.image.desktop.src,
//         },
//       },
//       overlay: {
//         top: item.overlayContentTop,
//         middle: item.overlayContentMiddle,
//         bottom: item.overlayContentBottom,
//       },
//       experimentIds: item.experimentIds,
//       variantIds: item.variantIds,
//     };
//   });
// }

// function* fetchHomePromotionalOffers() {
//   try {
//     yield put({ type: FETCH_HOME_PROMO_STARTED });
//     const language = yield select(getLanguage);
//     const bannerUrl = yield select(getHomeBannerUrl);
//     const res = yield call(
//       myAxaFetchWithToken,
//       `${bannerUrl}&language=${language.toUpperCase()}&device=WEB`,
//       {
//         method: 'GET',
//       },
//     );
//     if (res && res.status === 200) {
//       const response = yield res.json();
//       let { data, userProfile } = filterBanner(response, 'home-floating');
//       data = mapBannerObject(data);
//       if (data && data.length > 0) {
//         const payload = {
//           data,
//           language,
//           profile: userProfile,
//         };
//         yield put({ type: FETCH_HOME_PROMO_SUCCESS, payload });
//       } else {
//         yield put({ type: FETCH_HOME_PROMO_NOT_FOUND, payload: {} });
//       }
//     } else {
//       throw res;
//     }
//   } catch (e) {
//     console.log('[promo] error', e);
//     yield put({ type: FETCH_HOME_PROMO_FAILURE, payload: e });
//   }
// }

function* promoSaga() {
  // HKEMMA-102970 - /banners API decomission as depreciated since Emma1.5
  // yield take(FRAME_APP_MOUNTED);
  // yield fork(fetchHomePromotionalOffers);
}

export default promoSaga;
